// Footer.js
import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="copyright">© {currentYear} Ebusso</div>
      </div>
    </footer>
  );
}

export default Footer;
